import utils from '@/utils'
import global from '../config/index.js'
import { getCookie, removeCookie } from "./cookies";
import axios from 'axios'
import expireService from '@/utils/expired'
import router from '@/routers'
import { Message } from 'element-ui';
// 将全局变量绑定到全局
var $global_api = global

export function failureHandling (code) {
    if (code == 'ZUUL_ERROR_00002') { // token已过期
      removeCookie(process.env.TOKEN_KEY) // 清除token 及 cookie
      removeCookie(process.env.USERID_KEY)
      removeCookie('org')
      removeCookie('query_record')
      removeCookie('ifrm_031')
      Message.error('页面已过期,即将跳转到登录页')
      var isIP = utils.isIP(window.location.hostname);
      if (!isIP) { // 域名/localhost的情况
        if (window.location.hostname == 'localhost') {
          window.location.href = 'http://localhost:8080'
        } else {
          window.location.href = 'http://' + $global_api.DEFAULT_DOMAIN + ':' + $global_api.webport
        }
      } else {
        if ($global_api.DEPLOY) {
          window.location.href = 'http://' + window.location.hostname
        } else {
          window.location.href = 'http://' + window.location.hostname + ':' + $global_api.webport
        }
      }
    } else { // 将错误码报出来
      axios({
        method: 'GET',
        url: process.env.API_ROOT + '/bylBaseCenter/dict/getDict',
        params: {type: 'message', value: code},
        withCredentials: false
      })
        .then(function (res) {
          if (res.data.result === 'Success') {
            Message.error(res.data.data.label)
          } else if (res.data.result === 'Error') {
            console.log(`错误信息Code: ${res.data.message}`)
          }
        })
        .catch(function (err) {
          if (err) {
            console.log('error:' + err)
          }
        })
    }
  }



// WEBPACK FOOTER //
// ./src/utils/errorHandling.js